import { render, staticRenderFns } from "./transfering-minimization-filter.vue?vue&type=template&id=2708e706"
import script from "./transfering-minimization-filter.vue?vue&type=script&lang=js"
export * from "./transfering-minimization-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports